/* Aurora customizer: T-shirt with printable and unprintable areas. Front, back and both sleeves,
   drawn in code. Zones are proportions only: no measurements are claimed. */
(function () {
  'use strict';
  var L = window.AuroraCZ;

  // ---- geometry helpers (all in a 100-unit space unless a view says otherwise) ----
  function thick(pts, w) {
    var h = w / 2, left = [], right = [];
    for (var i = 0; i < pts.length; i++) {
      var a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)];
      var dx = b[0] - a[0], dy = b[1] - a[1], n = Math.hypot(dx, dy) || 1;
      var nx = -dy / n * h, ny = dx / n * h;
      left.push([pts[i][0] + nx, pts[i][1] + ny]);
      right.push([pts[i][0] - nx, pts[i][1] - ny]);
    }
    var all = left.concat(right.reverse()), p = new Path2D();
    p.moveTo(all[0][0], all[0][1]);
    for (var j = 1; j < all.length; j++) p.lineTo(all[j][0], all[j][1]);
    p.closePath();
    return p;
  }
  function seg(x1, y1, x2, y2, w) { return thick([[x1, y1], [x2, y2]], w); }
  function curve(p0, p1, p2, w) {
    var pts = [];
    for (var i = 0; i <= 14; i++) {
      var t = i / 14, u = 1 - t;
      pts.push([u * u * p0[0] + 2 * u * t * p1[0] + t * t * p2[0], u * u * p0[1] + 2 * u * t * p1[1] + t * t * p2[1]]);
    }
    return thick(pts, w);
  }
  function polygon(pts) {
    var p = new Path2D();
    p.moveTo(pts[0][0], pts[0][1]);
    for (var i = 1; i < pts.length; i++) p.lineTo(pts[i][0], pts[i][1]);
    p.closePath();
    return p;
  }
  function rectPath(x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    return new Path2D('M' + (x + r) + ' ' + y + ' H' + (x + w - r) + ' Q' + (x + w) + ' ' + y + ' ' + (x + w) + ' ' + (y + r) +
      ' V' + (y + h - r) + ' Q' + (x + w) + ' ' + (y + h) + ' ' + (x + w - r) + ' ' + (y + h) + ' H' + (x + r) +
      ' Q' + x + ' ' + (y + h) + ' ' + x + ' ' + (y + h - r) + ' V' + (y + r) + ' Q' + x + ' ' + y + ' ' + (x + r) + ' ' + y + ' Z');
  }
  function shrink(pts, f) {
    var cx = 0, cy = 0;
    pts.forEach(function (p) { cx += p[0]; cy += p[1]; });
    cx /= pts.length; cy /= pts.length;
    return pts.map(function (p) { return [cx + (p[0] - cx) * f, cy + (p[1] - cy) * f]; });
  }
  function mirror(pts) { return pts.map(function (p) { return [100 - p[0], p[1]]; }); }

  // ---- the shirt ----
  var BODY_D = ' L73 15 Q85 20 96 30 L88 46 L76 40 L76 89 Q50 93 24 89 L24 40 L12 46 L4 30 Q15 20 27 15 Z';
  var P_FRONT = new Path2D('M40 12 Q50 24 60 12' + BODY_D);
  var P_BACK = new Path2D('M40 12 Q50 15 60 12' + BODY_D);
  var SLEEVE_Q = [[27, 15], [4, 30], [12, 46], [24, 40]];

  function shirtBands(back) {
    return [
      back ? curve([40, 12], [50, 15], [60, 12], 4.6) : curve([40, 12], [50, 24], [60, 12], 5.4),   // collar
      seg(40, 12, 27, 15, 3.6), seg(60, 12, 73, 15, 3.6),                                           // shoulder seams
      seg(27, 15, 24, 40, 3.2), seg(73, 15, 76, 40, 3.2),                                           // armhole seams
      seg(24, 40, 24, 89, 3.2), seg(76, 40, 76, 89, 3.2),                                           // side seams
      seg(12, 46, 24, 40, 3), seg(88, 46, 76, 40, 3),                                               // sleeve underside
      seg(4, 30, 12, 46, 4.4), seg(96, 30, 88, 46, 4.4),                                            // sleeve cuffs
      polygon([[24, 83.2], [76, 83.2], [76, 96], [24, 96]])                                         // hem, below the hem seam
    ];
  }
  var BANDS_FRONT = shirtBands(false), BANDS_BACK = shirtBands(true);

  var SLEEVE_D = 'M5 14 Q25 -4 45 14 L41 52 L9 52 Z';
  var P_SLEEVE = new Path2D(SLEEVE_D);
  var BANDS_SLEEVE = [
    curve([5, 14], [25, -4], [45, 14], 4.2),
    seg(5, 14, 9, 52, 3.2), seg(45, 14, 41, 52, 3.2),
    polygon([[8, 46], [42, 46], [43, 56], [7, 56]])
  ];

  var SL = shrink(SLEEVE_Q, 0.55);
  var SLEEVE_ZONES_ON_BODY = [polygon(SL), polygon(mirror(SL))];

  // printable panels and the positions inside them (units)
  var VIEWS = {
    front: { path: P_FRONT, bands: BANDS_FRONT, back: false, K: 8, ox: 50, oy: 30,
             zones: [rectPath(29, 21.5, 42, 60, 1.2)].concat(SLEEVE_ZONES_ON_BODY) },
    back:  { path: P_BACK, bands: BANDS_BACK, back: true, K: 8, ox: 50, oy: 30,
             zones: [rectPath(29, 18.5, 42, 63, 1.2)] },
    sleeveL: { path: P_SLEEVE, bands: BANDS_SLEEVE, sleeve: true, K: 12, ox: 150, oy: 120,
               zones: [rectPath(14, 17, 22, 26, 1.2)] }
  };
  VIEWS.sleeveR = VIEWS.sleeveL;
  var AREAS = {
    'front.full':  { view: 'front', x: 30, y: 22, w: 40, h: 58 },
    'front.chest': { view: 'front', x: 35, y: 26, w: 30, h: 30 },
    'front.left':  { view: 'front', x: 58, y: 25, w: 10, h: 10 },
    'back.full':   { view: 'back',  x: 30, y: 20, w: 40, h: 60 },
    'back.tag':    { view: 'back',  x: 42, y: 19.5, w: 16, h: 8 },
    'sleeveL.main': { view: 'sleeveL', x: 15, y: 19, w: 20, h: 22 },
    'sleeveR.main': { view: 'sleeveR', x: 15, y: 19, w: 20, h: 22 }
  };
  var FIRST_AREA = { front: 'front.full', back: 'back.full', sleeveL: 'sleeveL.main', sleeveR: 'sleeveR.main' };

  function shade(hex, f) {
    var n = parseInt(hex.slice(1), 16);
    function ch(v) { return Math.max(0, Math.min(255, Math.round(v * f))); }
    return 'rgb(' + ch((n >> 16) & 255) + ',' + ch((n >> 8) & 255) + ',' + ch(n & 255) + ')';
  }

  // diagonal hatching inside one unprintable region (spacing given in screen px)
  function hatch(c, region, K, body) {
    c.save();
    if (body) c.clip(body);
    c.fillStyle = 'rgba(194,64,47,0.16)'; c.fill(region);
    c.clip(region);
    c.strokeStyle = 'rgba(194,64,47,0.6)'; c.lineWidth = 1.1 / K;
    var s = 7 / K;
    c.beginPath();
    for (var t = -120; t < 220; t += s) { c.moveTo(t, 0); c.lineTo(t - 120, 120); }
    c.stroke();
    c.restore();
  }

  // surface texture per fabric: a plain weave for cotton, a finer knit for the cooling fabric
  var texCache = {};
  function texture(m) {
    if (texCache[m]) return texCache[m];
    var size = 96, cv = document.createElement('canvas'), x, i;
    cv.width = cv.height = size; x = cv.getContext('2d');
    if (m === 'cool') {
      for (i = 0; i < size; i += 2) { x.fillStyle = 'rgba(0,0,0,0.035)'; x.fillRect(i, 0, 1, size); }
      for (i = 0; i < size; i += 4) { x.fillStyle = 'rgba(255,255,255,0.03)'; x.fillRect(0, i, size, 1); }
    } else {
      for (i = 0; i < size; i += 3) {
        x.fillStyle = 'rgba(0,0,0,0.032)'; x.fillRect(i, 0, 1, size);
        x.fillStyle = 'rgba(0,0,0,0.026)'; x.fillRect(0, i, size, 1);
        x.fillStyle = 'rgba(255,255,255,0.022)'; x.fillRect(i + 1, 0, 1, size);
      }
    }
    texCache[m] = cv;
    return cv;
  }

  function init(root) {
    var t = L.i18n(root);
    var canvas = root.querySelector('[data-cz-canvas]');
    var ctx = canvas.getContext('2d');
    var empty = root.querySelector('[data-cz-empty]');
    var status = root.querySelector('[data-cz-status]');
    var hint = root.querySelector('[data-cz-hint]');
    var dlBtn = root.querySelector('[data-cz-download]');
    var mailLink = root.querySelector('[data-cz-mail]');
    var legend = root.querySelector('[data-cz-legend]');
    var mail = root.getAttribute('data-mail') || '';

    var st = { pic: null, view: 'front', area: 'front.full', base: '#f1efe9', material: 'cotton', showZones: true, pl: {} };
    Object.keys(AREAS).forEach(function (k) { st.pl[k] = new L.Placement('contain'); });
    function say(m, k) { L.say(status, m, k); }

    function paint(c, opts) {
      var v = VIEWS[st.view], K = v.K, a = AREAS[st.area];
      c.save();
      c.translate(v.ox, v.oy); c.scale(K, K);

      c.save();
      if (opts.shadow) { c.shadowColor = 'rgba(15,32,25,0.22)'; c.shadowBlur = 30 / K; c.shadowOffsetY = 12 / K; }
      c.fillStyle = st.base; c.fill(v.path);
      c.restore();

      if (!v.sleeve && !v.back) {
        c.fillStyle = shade(st.base, 0.74);
        c.fill(new Path2D('M40 12 Q50 24 60 12 Q50 6.5 40 12 Z'));
      }

      // the picture, held inside its position
      if (st.pic) {
        var box = { x: a.x, y: a.y, w: a.w, h: a.h };
        c.save();
        c.beginPath(); c.rect(a.x, a.y, a.w, a.h); c.clip();
        L.drawPic(c, st.pic, st.pl[st.area], box);
        c.restore();
      }

      // fabric light and shadow over shirt and print together
      c.save();
      c.clip(v.path);
      var gx = c.createLinearGradient(0, 0, 100, 0);
      if (v.sleeve) {
        gx = c.createLinearGradient(5, 0, 45, 0);
        gx.addColorStop(0, 'rgba(0,0,0,0.14)'); gx.addColorStop(0.5, 'rgba(255,255,255,0.06)'); gx.addColorStop(1, 'rgba(0,0,0,0.14)');
        c.fillStyle = gx; c.fillRect(-5, -5, 60, 70);
      } else {
        gx = c.createLinearGradient(4, 0, 96, 0);
        gx.addColorStop(0, 'rgba(0,0,0,0.16)'); gx.addColorStop(0.16, 'rgba(0,0,0,0.03)');
        gx.addColorStop(0.5, 'rgba(255,255,255,0.06)'); gx.addColorStop(0.84, 'rgba(0,0,0,0.03)');
        gx.addColorStop(1, 'rgba(0,0,0,0.16)');
        c.fillStyle = gx; c.fillRect(0, 0, 100, 100);
        var gy = c.createLinearGradient(0, 12, 0, 93);
        gy.addColorStop(0, 'rgba(255,255,255,0.07)'); gy.addColorStop(1, 'rgba(0,0,0,0.12)');
        c.fillStyle = gy; c.fillRect(0, 0, 100, 100);
        c.lineCap = 'round';
        c.strokeStyle = 'rgba(0,0,0,0.045)'; c.lineWidth = 3.2;
        c.beginPath(); c.moveTo(27, 42); c.quadraticCurveTo(33, 62, 27, 84); c.stroke();
        c.beginPath(); c.moveTo(73, 42); c.quadraticCurveTo(67, 62, 73, 84); c.stroke();
      }
      c.restore();

      // the fabric surface over shirt and print together
      c.save();
      c.clip(v.path);
      c.setTransform(1, 0, 0, 1, 0, 0);
      c.fillStyle = c.createPattern(texture(st.material), 'repeat');
      c.fillRect(0, 0, c.canvas.width, c.canvas.height);
      if (st.material === 'cool') {
        var sh = c.createLinearGradient(v.ox, v.oy, v.ox + 100 * v.K, v.oy + 100 * v.K);
        sh.addColorStop(0, 'rgba(255,255,255,0.14)'); sh.addColorStop(0.5, 'rgba(255,255,255,0)'); sh.addColorStop(1, 'rgba(0,0,0,0.05)');
        c.fillStyle = sh; c.fillRect(0, 0, c.canvas.width, c.canvas.height);
      }
      c.restore();

      // seams and hems as thin lines, and the collar rib
      if (!v.sleeve) {
        c.save(); c.lineCap = 'round';
        c.strokeStyle = shade(st.base, 0.82); c.lineWidth = 2.1;
        c.beginPath(); c.moveTo(40, 12); c.quadraticCurveTo(50, v.back ? 15 : 24, 60, 12); c.stroke();
        c.strokeStyle = 'rgba(0,0,0,0.16)'; c.lineWidth = 0.3;
        c.beginPath(); c.moveTo(27, 15); c.lineTo(24, 40); c.moveTo(73, 15); c.lineTo(76, 40);
        c.moveTo(24, 83.2); c.lineTo(76, 83.2); c.stroke();
        c.restore();
      }

      if (opts.shadow) {
        c.lineJoin = 'round'; c.lineWidth = 0.35; c.strokeStyle = 'rgba(15,32,25,0.22)'; c.stroke(v.path);

        if (st.showZones) {
          v.bands.forEach(function (b) { hatch(c, b, K, v.path); });
          c.save();
          v.zones.forEach(function (z) {
            c.fillStyle = 'rgba(30,201,192,0.07)'; c.fill(z);
            c.setLineDash([1.6, 1.1]); c.lineWidth = 0.4; c.strokeStyle = 'rgba(14,150,140,0.95)'; c.stroke(z);
          });
          c.restore();
        }
        // the position the picture will print in
        c.save();
        c.lineWidth = 0.5; c.strokeStyle = 'rgba(15,74,48,0.9)'; c.setLineDash([]);
        c.strokeRect(a.x, a.y, a.w, a.h);
        c.restore();
      }
      c.restore();
    }

    var queued = false;
    function draw() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        paint(ctx, { shadow: true });
      });
    }

    var ctl = L.controls(root, draw);
    var viewBtns = root.querySelectorAll('[data-view]');
    var areaBtns = root.querySelectorAll('[data-area]');

    function showAreaChips() {
      areaBtns.forEach(function (b) {
        var ok = b.getAttribute('data-for') === st.view;
        b.hidden = !ok;
        var on = b.getAttribute('data-area') === st.area;
        b.classList.toggle('is-on', on && ok); b.setAttribute('aria-checked', on && ok ? 'true' : 'false');
      });
    }
    function refreshUI() {
      ctl.bind(st.pic ? st.pl[st.area] : null);
      dlBtn.disabled = !st.pic; empty.hidden = !!st.pic; hint.hidden = !st.pic;
      showAreaChips();
    }
    function updateMail() {
      var extra = '\n\n' + L.label(root, '[data-view].is-on') + ' / ' + L.label(root, '[data-area].is-on') + ' / ' + L.label(root, '[data-material].is-on') + ' / ' + L.label(root, '[data-base].is-on');
      L.mail(mailLink, mail, t.mailSubject, (t.mailBody || '') + extra);
    }

    var drop = root.querySelector('[data-cz-drop]');
    L.bindUpload(drop, drop.querySelector('input'), function (file) {
      L.loadFile(file, t, say, function (pic) {
        st.pic = pic;
        Object.keys(st.pl).forEach(function (k) { st.pl[k].reset(); });
        refreshUI(); draw();
      });
    });

    viewBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.view = b.getAttribute('data-view'); st.area = FIRST_AREA[st.view];
      L.radio(viewBtns, b); refreshUI(); updateMail(); draw(); }); });
    areaBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.area = b.getAttribute('data-area'); refreshUI(); updateMail(); draw(); }); });
    var matBtns = root.querySelectorAll('[data-material]');
    matBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.material = b.getAttribute('data-material'); L.radio(matBtns, b); updateMail(); draw(); }); });
    var baseBtns = root.querySelectorAll('[data-base]');
    baseBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.base = b.getAttribute('data-base'); L.radio(baseBtns, b); updateMail(); draw(); }); });
    root.querySelectorAll('[data-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-toggle'); st[k] = !st[k];
        b.classList.toggle('is-on', st[k]); b.setAttribute('aria-pressed', st[k] ? 'true' : 'false');
        if (legend) legend.hidden = !st.showZones;
        draw();
      });
    });

    L.dragger(canvas, {
      current: function () {
        if (!st.pic) return null;
        var a = AREAS[st.area], K = VIEWS[st.view].K;
        return { pl: st.pl[st.area], w: a.w * K, h: a.h * K };
      },
      onZoom: function () { ctl.refresh(); },
      onChange: draw
    });

    dlBtn.addEventListener('click', function () {
      if (!st.pic) return;
      var out = document.createElement('canvas');
      out.width = canvas.width; out.height = canvas.height;
      paint(out.getContext('2d'), { shadow: false });
      L.download(out, (t.fileName || 'aurora-tshirt-preview') + '-' + st.area.replace('.', '-') + '.png');
    });

    refreshUI(); updateMail(); draw();
  }

  L.boot('[data-aurora-cz-tee]', init);
})();
